import { useEffect, useRef } from 'react';
import { trackPosterImpression } from '../utils/curatorAnalytics';

export function usePosterCardAnalytics(analytics, item) {
  const cardRef = useRef(null);
  const impressedRef = useRef(false);

  useEffect(() => {
    impressedRef.current = false;
  }, [analytics?.page, analytics?.shelf, analytics?.index, item?.tmdbId, item?.id]);

  useEffect(() => {
    const node = cardRef.current;
    if (!node || !analytics || !item || impressedRef.current) return undefined;

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.some((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.5);
        if (!visible || impressedRef.current) return;
        impressedRef.current = true;
        trackPosterImpression({
          page: analytics.page,
          shelf: analytics.shelf,
          index: analytics.index,
          tmdbId: item.tmdbId || item.id,
          title: item.title || item.name,
          mediaType: item.mediaType,
        });
        observer.disconnect();
      },
      { threshold: [0.5, 0.75] },
    );

    observer.observe(node);
    return () => observer.disconnect();
  }, [analytics, item]);

  return cardRef;
}
